import { vappContainer, VApplication } from '../../../../../application';
import { logger as log } from '@common/logger';
import { DraftAppPageService } from '../../../services';

const MODULE_NAME = 'profile.machines.states.reinviteUser';

const getSrv = () => {
  return vappContainer.get<DraftAppPageService>(
    DraftAppPageService.displayName
  );
};

export const reinviteUser = async (context: any, event: any) => {
  const currentState = 'REINVITE_USER';
  const method = 'revokeCred';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.getReinviteUser(event?.payload);
      if (content) {
        return resolve({
          key: 'REINVITE_USER_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'User deletion failed';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'REINVITE_USER_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'REINVITE_USER_FAILED',
        value: _msg,
      });
    }
  });
};
